<template>
  <div class="container sv sv043">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>いまさら聞けない！ローンの基礎知識</HeadingOne>

    <p class="_mb-md-60">
      ローン初心者の方に向けて、
      ローンに関する気になる疑問や不安にお答えします。
    </p>

    <section id="section_01">
      <CardGroups class="-image-top-list">
        <CardBox router-name="sv009" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv009/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンにおける金利の仕組みとは？</h3>
          </CardHeader>
          <CardBody
            >「金利・利息・実質年率ってなんだろう？」いまさら聞けないローンのキホンについて！</CardBody
          >
        </CardBox>
        <CardBox router-name="sv010" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv010/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンの返済方法やルールとは？</h3>
          </CardHeader>
          <CardBody
            >「お金を借りたらどうやって返すの…？」au PAY
            スマートローンの返済方法についてはこちら。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv011" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv011/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンって借りすぎないかな？</h3>
          </CardHeader>
          <CardBody
            >借り入れできる金額には制限があるんです！「いつのまにか借りすぎてしまうことってないかな…？」なんて方はこちら。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv012" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv012/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">お金を借りたいけど、周りの人に知られない？</h3>
          </CardHeader>
          <CardBody
            >「ローンのこと気になっていたけど、家族や恋人に知られないかな？」にお答えします。</CardBody
          >
        </CardBox>
      </CardGroups>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal -lg" router-name="sv003">
          知っておきたい！ローンについてへ戻る
        </BtnMain>
      </BtngroupSingle>

      <CvBox class="_mb-120 _mb-sm-60" />
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import CardImage from "@/components/card/CardImage";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";

export default {
  name: "Sv043",
  components: {
    BreadcrumbGroup,
    HeadingOne,
    CardGroups,
    CardBox,
    CardHeader,
    CardBody,
    CardImage,
    BtngroupSingle,
    BtnMain,
    CvBox,
  },
  setup() {
    setMeta({
      title:
        "いまさら聞けない！ローンの基礎知識｜知っておきたい！ローンについて",
      description:
        "意外と知らないローンの基礎知識！ローン初心者の方に向けて、ローンに関する気になる疑問や不安について初心者でも分かりやすくご説明します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,ローン知識,金利",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "いまさら聞けない！ローンの基礎知識",
          active: true,
        },
      ],
    };
  },
};
</script>

<style scoped></style>
